
/* nailARTS Seasonal Magic, variant 2. Original artwork, local pixel deformation. */
(() => {
  'use strict';
  if (window.naSeasonalMagicV2) { window.naSeasonalMagicV2.scan(); return; }
  const selector = '[data-na-magic-root]';
  const controllers = new Map();
  let activeOwner = null;
  const random = (a, b) => a + Math.random() * (b - a);
  const choose = list => list[Math.floor(Math.random() * list.length)];

  // Header boundary for the cobweb and spider
  function visibleHeaderBottom() {
    const nodes = document.querySelectorAll(
      '.header-wrapper, .shopify-section-header-sticky, .section-header, ' +
      '[id^="shopify-section-"][id$="__header"], #shopify-section-header, header'
    );

    let bottom = 0;

    for (const node of nodes) {
      const rect = node.getBoundingClientRect();

      if (rect.width < innerWidth * 0.6 || rect.height <= 0) continue;
      if (rect.bottom <= 0 || rect.top > Math.min(220, innerHeight * 0.3)) continue;
      if (rect.bottom > Math.min(420, innerHeight * 0.5)) continue;

      bottom = Math.max(bottom, rect.bottom);
    }

    return Math.round(bottom);
  }

  // Artwork and its approved internal motion remain untouched.
  // Sizes are ~15% larger; grounded characters remain at the bottom.
  const characters = [
    { id: 'ghost', mode: 0, size: [86, 132], motions: ['fly-left', 'fly-right'] },
    { id: 'bat', mode: 1, size: [98, 144], motions: ['fly-left', 'fly-right'] },
    { id: 'witch', mode: 2, size: [138, 207], motions: ['grounded'] },
    { id: 'cat', mode: 3, size: [98, 150], motions: ['grounded'] },
    { id: 'spider', mode: 4, size: [110, 145], motions: ['drop'] },
    { id: 'web', mode: 5, size: [115, 184], motions: ['web'] },
    { id: 'pumpkin', mode: 6, size: [115, 165], motions: ['grounded'] },
    { id: 'mummy', motions: ['runner'] }
  ];

  const vertexSource = `
    precision mediump float;
    attribute vec2 position;
    varying vec2 uv;
    uniform float time;
    uniform float mode;
    uniform float amount;
    float bell(vec2 p, vec2 c, vec2 r) {
      vec2 q = (p-c)/r;
      return 1.0-smoothstep(0.45,1.0,length(q));
    }
    vec2 eye(vec2 p, vec2 c, vec2 r, float blink) {
      float w = bell(p,c,r);
      return vec2(0.0, -(p.y-c.y)*blink*w);
    }
    void main() {
      uv = position;
      vec2 p = position;
      vec2 d = vec2(0.0);
      float t = time*1.4959965;
      if (mode < 0.5) {
        float hem = smoothstep(0.50,0.93,p.y);
        d.x = sin(t*2.0+p.y*9.0)*0.022*hem;
        d.y = sin(t*2.0+p.x*12.0)*0.016*hem;
      } else if (mode < 1.5) {
        float flap = sin(t*6.0);
        float leftHinge = 0.31+0.12*smoothstep(0.40,0.75,p.y);
        float rightHinge = 0.76-0.09*smoothstep(0.35,0.65,p.y);
        float left = 1.0-smoothstep(leftHinge-0.025,leftHinge+0.025,p.x);
        float right = smoothstep(rightHinge-0.025,rightHinge+0.025,p.x);
        float wing = max(left,right);
        d.x = (p.x-0.54)*(-0.20*(flap+1.0)*0.5)*wing;
        d.y = (abs(p.x-0.54))*0.20*flap*wing;
      } else if (mode < 2.5) {
        float cloak = (1.0-smoothstep(0.27,0.43,p.x))*smoothstep(0.48,0.86,p.y);
        float hair = bell(p,vec2(0.78,0.65),vec2(0.12,0.15))*smoothstep(0.71,0.76,p.x);
        d.x = sin(t*2.0+p.y*11.0)*(0.014*cloak+0.009*hair);
        d.y = cos(t*2.0+p.x*8.0)*0.009*cloak;
      } else if (mode < 3.5) {
        float phase = mod(time,4.2);
        float blink = smoothstep(1.95,2.07,phase)*(1.0-smoothstep(2.13,2.27,phase))*0.92;
        d += eye(p,vec2(0.424,0.458),vec2(0.142,0.112),blink);
        d += eye(p,vec2(0.710,0.345),vec2(0.135,0.108),blink);
      } else if (mode < 4.5) {
        float legs = max(1.0-smoothstep(0.20,0.33,p.x),smoothstep(0.68,0.80,p.x))*smoothstep(0.45,0.70,p.y);
        d.x = sin(t*3.0+p.y*18.0)*0.018*legs;
        d.y = cos(t*3.0+p.y*18.0)*0.014*legs;
      } else if (mode < 5.5) {
        float pendant = bell(p,vec2(0.21,0.22),vec2(0.12,0.11))
          +bell(p,vec2(0.45,0.55),vec2(0.11,0.13))
          +bell(p,vec2(0.73,0.71),vec2(0.11,0.12))
          +bell(p,vec2(0.94,0.89),vec2(0.08,0.10));
        d.x = sin(t*2.0+p.y*7.0)*0.008*pendant;
      } else {
        float stem = (1.0-smoothstep(0.25,0.48,p.y))*smoothstep(0.24,0.40,p.x)*(1.0-smoothstep(0.76,0.87,p.x));
        d.x = sin(t*2.0+p.y*5.0)*0.012*stem;
      }
      p += d*amount;
      p = p*0.88+0.06;
      gl_Position = vec4(p.x*2.0-1.0,1.0-p.y*2.0,0.0,1.0);
    }
  `;

  // Cat: independent tail sway and head tilt, without blinking.
  const catVertexSource = `
    precision mediump float;
    attribute vec2 position;
    varying vec2 uv;
    uniform float time;
    uniform float mode;
    uniform float amount;
    float bell(vec2 p, vec2 c, vec2 r) {
      vec2 q = (p-c)/r;
      return 1.0-smoothstep(0.45,1.0,length(q));
    }
    void main() {
      uv = position;
      vec2 p = position;
      vec2 d = vec2(0.0);
      float t = time*1.4959965;
      if (mode < 0.5) {
        float hem = smoothstep(0.50,0.93,p.y);
        d.x = sin(t*2.0+p.y*9.0)*0.022*hem;
        d.y = sin(t*2.0+p.x*12.0)*0.016*hem;
      } else if (mode < 1.5) {
        float flap = sin(t*6.0);
        float leftHinge = 0.31+0.12*smoothstep(0.40,0.75,p.y);
        float rightHinge = 0.76-0.09*smoothstep(0.35,0.65,p.y);
        float left = 1.0-smoothstep(leftHinge-0.025,leftHinge+0.025,p.x);
        float right = smoothstep(rightHinge-0.025,rightHinge+0.025,p.x);
        float wing = max(left,right);
        d.x = (p.x-0.54)*(-0.20*(flap+1.0)*0.5)*wing;
        d.y = (abs(p.x-0.54))*0.20*flap*wing;
      } else if (mode < 2.5) {
        float cloak = (1.0-smoothstep(0.27,0.43,p.x))*smoothstep(0.48,0.86,p.y);
        float hair = bell(p,vec2(0.78,0.65),vec2(0.12,0.15))*smoothstep(0.71,0.76,p.x);
        d.x = sin(t*2.0+p.y*11.0)*(0.014*cloak+0.009*hair);
        d.y = cos(t*2.0+p.x*8.0)*0.009*cloak;
      } else if (mode < 3.5) {
        const float aspect = 403.0/530.0;
        float tailAngle = sin(time*2.2439948+0.45)*0.06108652;
        vec2 tailPivot = vec2(0.32,0.91);
        vec2 tailPoint = (p-tailPivot)*vec2(aspect,1.0);
        vec2 tailTurned = vec2(
          cos(tailAngle)*tailPoint.x-sin(tailAngle)*tailPoint.y,
          sin(tailAngle)*tailPoint.x+cos(tailAngle)*tailPoint.y
        )/vec2(aspect,1.0)+tailPivot;
        float tailWeight = (1.0-smoothstep(0.33,0.42,p.x))
          *smoothstep(0.555,0.610,p.y)*(1.0-smoothstep(0.85,0.955,p.y));
        d += (tailTurned-p)*tailWeight;
        float headAngle = sin(time*1.4959965-0.35)*0.03141593;
        vec2 headPivot = vec2(0.53,0.61);
        vec2 headPoint = (p-headPivot)*vec2(aspect,1.0);
        vec2 headTurned = vec2(
          cos(headAngle)*headPoint.x-sin(headAngle)*headPoint.y,
          sin(headAngle)*headPoint.x+cos(headAngle)*headPoint.y
        )/vec2(aspect,1.0)+headPivot;
        float headWeight = (1.0-smoothstep(0.58,0.665,p.y))
          *(1.0-smoothstep(0.54,0.58,p.y)*(1.0-smoothstep(0.25,0.33,p.x)));
        d += (headTurned-p)*headWeight;
      } else if (mode < 4.5) {
        float legs = max(1.0-smoothstep(0.20,0.33,p.x),smoothstep(0.68,0.80,p.x))*smoothstep(0.45,0.70,p.y);
        d.x = sin(t*3.0+p.y*18.0)*0.018*legs;
        d.y = cos(t*3.0+p.y*18.0)*0.014*legs;
      } else if (mode < 5.5) {
        float pendant = bell(p,vec2(0.21,0.22),vec2(0.12,0.11))
          +bell(p,vec2(0.45,0.55),vec2(0.11,0.13))
          +bell(p,vec2(0.73,0.71),vec2(0.11,0.12))
          +bell(p,vec2(0.94,0.89),vec2(0.08,0.10));
        d.x = sin(t*2.0+p.y*7.0)*0.008*pendant;
      } else {
        float stem = (1.0-smoothstep(0.25,0.48,p.y))*smoothstep(0.24,0.40,p.x)*(1.0-smoothstep(0.76,0.87,p.x));
        d.x = sin(t*2.0+p.y*5.0)*0.012*stem;
      }
      p += d*amount;
      p = p*0.88+0.06;
      gl_Position = vec4(p.x*2.0-1.0,1.0-p.y*2.0,0.0,1.0);
    }
  `;

  const fragmentSource = `
    precision mediump float;
    varying vec2 uv;
    uniform sampler2D artwork;
    uniform float time;
    uniform float mode;
    uniform float amount;
    void main() {
      vec4 color = texture2D(artwork,uv);
      if (mode > 5.5) {
        float face = (1.0-smoothstep(0.20,0.38,abs(uv.x-0.50)))
          *smoothstep(0.45,0.57,uv.y)*(1.0-smoothstep(0.82,0.91,uv.y));
        color.rgb *= 1.0+0.10*(0.5+0.5*sin(time*2.991993))*face*amount;
      }
      gl_FragColor = color;
    }
  `;

  class ArtworkRenderer {
    constructor(canvas) {
      this.canvas = canvas;
      const gl = canvas.getContext('webgl', {
        alpha: true,
        premultipliedAlpha: true,
        antialias: true,
        depth: false,
        stencil: false,
        preserveDrawingBuffer: false
      });
      if (!gl) throw new Error('WebGL unavailable');
      this.gl = gl;

      const compile = (type, source) => {
        const shader = gl.createShader(type);
        gl.shaderSource(shader, source);
        gl.compileShader(shader);
        if (!gl.getShaderParameter(shader, gl.COMPILE_STATUS)) {
          const reason = gl.getShaderInfoLog(shader);
          gl.deleteShader(shader);
          throw new Error(reason);
        }
        return shader;
      };

      const vertex = compile(gl.VERTEX_SHADER, vertexSource);
      const fragment = compile(gl.FRAGMENT_SHADER, fragmentSource);
      this.program = gl.createProgram();
      gl.attachShader(this.program, vertex);
      gl.attachShader(this.program, fragment);
      gl.linkProgram(this.program);
      gl.deleteShader(vertex);
      gl.deleteShader(fragment);
      if (!gl.getProgramParameter(this.program, gl.LINK_STATUS)) {
        throw new Error(gl.getProgramInfoLog(this.program));
      }

      this.approvedProgram = this.program;
      this.catProgram = null;
      this.compile = compile;

      gl.useProgram(this.program);
      const steps = 64, vertices = [], indices = [];
      for (let y = 0; y <= steps; y++) {
        for (let x = 0; x <= steps; x++) {
          vertices.push(x / steps, y / steps);
        }
      }
      for (let y = 0; y < steps; y++) {
        for (let x = 0; x < steps; x++) {
          const a = y * (steps + 1) + x;
          const b = a + steps + 1;
          indices.push(a, b, a + 1, a + 1, b, b + 1);
        }
      }

      this.vertexBuffer = gl.createBuffer();
      gl.bindBuffer(gl.ARRAY_BUFFER, this.vertexBuffer);
      gl.bufferData(gl.ARRAY_BUFFER, new Float32Array(vertices), gl.STATIC_DRAW);
      const location = gl.getAttribLocation(this.program, 'position');
      gl.enableVertexAttribArray(location);
      gl.vertexAttribPointer(location, 2, gl.FLOAT, false, 0, 0);

      this.indexBuffer = gl.createBuffer();
      gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, this.indexBuffer);
      gl.bufferData(gl.ELEMENT_ARRAY_BUFFER, new Uint16Array(indices), gl.STATIC_DRAW);
      this.count = indices.length;

      this.texture = gl.createTexture();
      gl.bindTexture(gl.TEXTURE_2D, this.texture);
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
      gl.pixelStorei(gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, true);
      gl.enable(gl.BLEND);
      gl.blendFunc(gl.ONE, gl.ONE_MINUS_SRC_ALPHA);

      this.time = gl.getUniformLocation(this.program, 'time');
      this.mode = gl.getUniformLocation(this.program, 'mode');
      this.amount = gl.getUniformLocation(this.program, 'amount');
      gl.uniform1i(gl.getUniformLocation(this.program, 'artwork'), 0);
    }

    setImage(image, mode, size) {
      const gl = this.gl;
      if (mode === 3 && !this.catProgram) {
        const vertex = this.compile(gl.VERTEX_SHADER, catVertexSource);
        const fragment = this.compile(gl.FRAGMENT_SHADER, fragmentSource);
        this.catProgram = gl.createProgram();
        gl.attachShader(this.catProgram, vertex);
        gl.attachShader(this.catProgram, fragment);
        gl.linkProgram(this.catProgram);
        gl.deleteShader(vertex);
        gl.deleteShader(fragment);
        if (!gl.getProgramParameter(this.catProgram, gl.LINK_STATUS)) {
          throw new Error(gl.getProgramInfoLog(this.catProgram));
        }
      }

      this.program = mode === 3 ? this.catProgram : this.approvedProgram;
      gl.useProgram(this.program);
      const location = gl.getAttribLocation(this.program, 'position');
      gl.bindBuffer(gl.ARRAY_BUFFER, this.vertexBuffer);
      gl.enableVertexAttribArray(location);
      gl.vertexAttribPointer(location, 2, gl.FLOAT, false, 0, 0);
      this.time = gl.getUniformLocation(this.program, 'time');
      this.mode = gl.getUniformLocation(this.program, 'mode');
      this.amount = gl.getUniformLocation(this.program, 'amount');
      gl.uniform1i(gl.getUniformLocation(this.program, 'artwork'), 0);

      const ratio = Math.min(window.devicePixelRatio || 1, 2);
      this.canvas.width = Math.ceil(size * ratio);
      this.canvas.height = Math.ceil(size * ratio * image.naturalHeight / image.naturalWidth);
      gl.viewport(0, 0, this.canvas.width, this.canvas.height);

      gl.bindTexture(gl.TEXTURE_2D, this.texture);
      gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, image);
      gl.uniform1f(this.mode, mode);
    }

    draw(seconds, amount = 1) {
      const gl = this.gl;
      gl.clearColor(0, 0, 0, 0);
      gl.clear(gl.COLOR_BUFFER_BIT);
      gl.uniform1f(this.time, seconds);
      gl.uniform1f(this.amount, amount);
      gl.drawElements(gl.TRIANGLES, this.count, gl.UNSIGNED_SHORT, 0);
    }

    destroy() {
      const gl = this.gl;
      gl.deleteTexture(this.texture);
      gl.deleteBuffer(this.vertexBuffer);
      gl.deleteBuffer(this.indexBuffer);
      gl.deleteProgram(this.approvedProgram);
      if (this.catProgram) gl.deleteProgram(this.catProgram);
      const extension = gl.getExtension('WEBGL_lose_context');
      if (extension) extension.loseContext();
    }
  }

  class Controller {
    constructor(root) {
      this.root = root;
      this.disposed = false;
      this.pending = false;
      this.generation = 0;
      this.images = new Map();
      this.failed = new Set();
      this.last = null;

      this.speed = Math.max(50, Math.min(150, Number(root.dataset.speed) || 100)) / 100;
      this.flightDuration = Math.max(8, Math.min(30, Number(root.dataset.flightDuration) || 16));
      this.stayDuration = Math.max(5, Math.min(25, Number(root.dataset.stayDuration) || 12));
      this.mobile = window.matchMedia('(max-width: 767px)');
      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.available = characters.filter(character =>
        root.querySelector(`template[data-na-character="${character.id}"]`)
      );
      this.interval = ({
        rare: [45000, 90000],
        normal: [25000, 50000],
        often: [10000, 25000]
      })[root.dataset.frequency] || [25000, 50000];

      this.refresh = () => {
        this.generation++;
        this.pending = false;
        clearTimeout(this.timer);
        this.cleanup();
        if (this.allowed()) this.schedule(5000, 12000);
      };

      this.mobile.addEventListener('change', this.refresh);
      this.reduced.addEventListener('change', this.refresh);
      document.addEventListener('visibilitychange', this.refresh);
      this.refresh();
    }

    allowed() {
      return !this.disposed &&
        !this.unavailable &&
        this.root.isConnected &&
        this.root.dataset.enabled === 'true' &&
        !document.hidden &&
        !this.reduced.matches &&
        !(this.mobile.matches && this.root.dataset.mobile === 'false');
    }

    schedule(min, max) {
      clearTimeout(this.timer);
      if (this.allowed()) {
        this.timer = setTimeout(() => this.spawn(), random(min, max));
      }
    }

    image(character) {
      if (!this.images.has(character.id)) {
        const image = new Image();
        image.crossOrigin = 'anonymous';
        image.decoding = 'async';
        const promise = new Promise((resolve, reject) => {
          const timeout = setTimeout(() => {
            image.onload = null;
            image.onerror = null;
            reject(new Error(`Artwork timed out: ${character.id}`));
          }, 15000);
          image.onload = () => { clearTimeout(timeout); resolve(image); };
          image.onerror = () => { clearTimeout(timeout); reject(new Error(`Artwork failed: ${character.id}`)); };
          image.src = this.root.querySelector(`template[data-na-character="${character.id}"]`).dataset.src;
        });
        this.images.set(character.id, promise);
      }
      return this.images.get(character.id);
    }

    async spawn() {
      if (!this.allowed() || this.pending) return;
      if (activeOwner) {
        this.schedule(5000, 10000);
        return;
      }

      const remaining = this.available.filter(c => !this.failed.has(c.id));
      if (!remaining.length) return;
      const alternatives = remaining.filter(c => c.id !== this.last);
      const character = choose(alternatives.length ? alternatives : remaining);
      this.pending = true;
      const generation = this.generation;

      try {
        const image = await this.image(character);
        if (!this.allowed() || generation !== this.generation) return;
        if (activeOwner) {
          this.schedule(5000, 10000);
          return;
        }

        if (character.id === 'mummy') {
          this.spawnMummy(image);
          return;
        }

        if (!this.renderer) {
          this.canvas = document.createElement('canvas');
          this.canvas.setAttribute('aria-hidden', 'true');
          this.renderer = new ArtworkRenderer(this.canvas);
          this.canvas.addEventListener('webglcontextlost', event => {
            if (this.disposed) return;
            event.preventDefault();
            this.unavailable = true;
            this.cleanup();
            clearTimeout(this.timer);
            this.root.dataset.naError = 'webgl-context-lost';
          });
        }

        const mobileCaps = {
          ghost: 0.30,
          bat: 0.32,
          witch: 0.40,
          cat: 0.35,
          spider: 0.34,
          web: 0.34,
          pumpkin: 0.34
        };
        const maxWidth = this.mobile.matches ? innerWidth * mobileCaps[character.id] : 260;
        const size = Math.min(random(...character.size), maxWidth);
        const motion = choose(character.motions);
        const duration = motion.startsWith('fly') ? this.flightDuration : this.stayDuration;

        this.renderer.setImage(image, character.mode, size);

        const item = document.createElement('span');
        this.item = item;
        item.className = `na-magic-item na-magic-item--${motion}`;
        item.dataset.character = character.id;
        item.style.setProperty('--na-size', `${Math.round(size)}px`);
        item.style.setProperty('--na-duration', `${duration}s`);


if (
  (character.id === 'bat' && motion === 'fly-left') ||
  (character.id === 'ghost' && motion === 'fly-left')
) {
  item.classList.add('na-magic-item--mirror-art');
}


        if (motion.startsWith('fly')) {
          item.style.setProperty('--na-top', `${random(15, 65)}%`);
        }

        if (motion === 'grounded') {
          const edge = Math.min(18, innerWidth * 0.035);
          const maxLeft = Math.max(edge, innerWidth - size - edge);
          item.style.left = `${Math.round(random(edge, maxLeft))}px`;
          item.style.top = 'auto';
        }

        if (motion === 'drop') {
          const edge = Math.min(18, innerWidth * 0.035);
          item.style.left = `${Math.round(random(edge, Math.max(edge, innerWidth - size - edge)))}px`;
          item.style.top = '0';
          item.style.setProperty('--na-drop-distance', `${random(26, 34).toFixed(1)}vh`);
        }

        
        const followsHeader = motion === 'web' || motion === 'drop';

        const updateHeader = () => {
          this.root.style.setProperty(
            '--na-header-bottom',
            `${visibleHeaderBottom()}px`
          );
        };

        if (followsHeader) updateHeader();

        if (motion === 'web') {
          this.root.classList.add('na-magic-web-active');
        }

        
        if (motion === 'drop') {
          const layer = document.createElement('span');
          layer.className = 'na-magic-spider-layer';

          const thread = document.createElement('span');
          thread.className = 'na-magic-spider-thread';

          layer.appendChild(thread);

          item.appendChild(this.canvas);
          layer.appendChild(item);

          this.spiderLayer = layer;
          this.spiderThread = thread;
          this.root.appendChild(layer);
        } else {
          item.appendChild(this.canvas);
          this.root.appendChild(item);
        }


        this.last = character.id;
        activeOwner = this;

        if (motion === 'grounded') {
          this.fadeTimer = setTimeout(() => {
            if (this.item === item && this.allowed()) {
              item.classList.add('na-magic-exiting');
            }
          }, Math.max(0, duration * 1000 - 550));
        }

        const started = performance.now();
        let previous = -Infinity;
        let lastHeaderUpdate = -Infinity;

        const frame = now => {
          if (!this.item || !this.allowed()) {
            this.cleanup();
            return;
          }

          if (followsHeader && now - lastHeaderUpdate > 100) {
            updateHeader();
            lastHeaderUpdate = now;
          }

          // Extend the thread from the header to the spider.
          if (motion === 'drop' && this.spiderThread && this.spiderLayer) {
            const spiderRect = item.getBoundingClientRect();
            const layerRect = this.spiderLayer.getBoundingClientRect();

            const threadX =
              spiderRect.left - layerRect.left + spiderRect.width / 2;

            const threadY =
              spiderRect.top - layerRect.top + spiderRect.height * 0.06;

            this.spiderThread.style.left = `${threadX}px`;
            this.spiderThread.style.height = `${Math.max(0, threadY)}px`;
          }

          if (now - previous >= 1000 / 30) {
            this.renderer.draw((now - started) / 1000 * this.speed);
            previous = now;
          }

          this.raf = requestAnimationFrame(frame);
        };

        this.renderer.draw(0);
        this.raf = requestAnimationFrame(frame);

        item.addEventListener('animationend', event => {
          if (event.target === item) this.finish();
        });

        this.safety = setTimeout(
          () => this.finish(),
          duration * 1000 + 1200
        );


      } catch (error) {
        if (this.canvas && !this.renderer) this.unavailable = true;
        this.failed.add(character.id);
        this.root.dataset.naError = error.message;
        console.warn('[nailARTS Seasonal Magic]', error.message);
        this.schedule(...this.interval);
      } finally {
        if (generation === this.generation) this.pending = false;
      }
    }

    
    spawnMummy(image) {
      if (image.naturalWidth !== 2000 || image.naturalHeight !== 704) {
        throw new Error('Unexpected Mummy atlas dimensions');
      }
      const canvas = document.createElement('canvas');
      canvas.setAttribute('aria-hidden', 'true');
      const context = canvas.getContext('2d');
      if (!context) throw new Error('Mummy Canvas 2D unavailable');

      const size = Math.min(272, innerWidth * 0.72);
      const height = size * 352 / 500;
      const ratio = Math.min(window.devicePixelRatio || 1, 2);
      canvas.width = Math.ceil(size * ratio);
      canvas.height = Math.ceil(height * ratio);
      context.setTransform(ratio, 0, 0, ratio, 0, 0);

      const item = document.createElement('span');
      item.className = 'na-magic-mummy-runner';
      item.dataset.character = 'mummy';
      item.style.width = `${size}px`;
      item.style.height = `${height}px`;
      item.style.bottom = `${-size * 12 / 500}px`;
      const direction = choose(['right', 'left']);
      const duration = 9;
      const started = performance.now();
      let previousFrame = -1;

      const draw = seconds => {
        const frame = Math.floor(seconds * 10 * this.speed) % 8;
        if (frame === previousFrame) return;
        previousFrame = frame;
        context.clearRect(0, 0, size, height);
        context.save();
        if (direction === 'left') {
          context.translate(size, 0);
          context.scale(-1, 1);
        }
        context.drawImage(image, (frame % 4) * 500, Math.floor(frame / 4) * 352,
          500, 352, 0, 0, size, height);
        context.restore();
      };
      const move = seconds => {
        const width = innerWidth;
        const progress = Math.min(1, seconds / duration);
        const distance = width + size * 2;
        const x = direction === 'right' ? -size + progress * distance :
          width + size - progress * distance;
        item.style.transform = `translate3d(${x}px,0,0)`;
      };

      draw(0);
      move(0);
      item.appendChild(canvas);
      this.item = item;
      this.last = 'mummy';
      activeOwner = this;
      this.root.appendChild(item);

      const frame = now => {
        if (this.item !== item) return;
        if (!this.allowed()) {
          this.cleanup();
          return;
        }
        const seconds = (now - started) / 1000;
        move(seconds);
        draw(seconds);
        if (seconds >= duration) {
          this.finish();
          return;
        }
        this.raf = requestAnimationFrame(frame);
      };
      this.raf = requestAnimationFrame(frame);
      this.safety = setTimeout(() => this.finish(), duration * 1000 + 1200);
    }

    cleanup() {
      cancelAnimationFrame(this.raf);
      clearTimeout(this.safety);
      clearTimeout(this.fadeTimer);

      if (this.item) this.item.remove();
      this.item = null;

      if (this.spiderLayer) this.spiderLayer.remove();
      this.spiderLayer = null;

      this.root.classList.remove('na-magic-web-active');

      if (activeOwner === this) activeOwner = null;
    }


    finish() {
      this.cleanup();
      this.schedule(...this.interval);
    }

    destroy() {
      this.disposed = true;
      this.generation++;
      clearTimeout(this.timer);
      this.cleanup();
      this.mobile.removeEventListener('change', this.refresh);
      this.reduced.removeEventListener('change', this.refresh);
      document.removeEventListener('visibilitychange', this.refresh);
      if (this.renderer) this.renderer.destroy();
      this.images.clear();
    }
  }

  function scan() {
    for (const [root, controller] of controllers) {
      if (!root.isConnected) {
        controller.destroy();
        controllers.delete(root);
      }
    }
    document.querySelectorAll(selector).forEach(root => {
      if (!controllers.has(root)) {
        controllers.set(root, new Controller(root));
      }
    });
  }

  window.naSeasonalMagicV2 = { scan };
  document.addEventListener('shopify:section:load', scan);
  document.addEventListener('shopify:section:unload', event => {
    for (const [root, controller] of controllers) {
      if (event.target.contains(root)) {
        controller.destroy();
        controllers.delete(root);
      }
    }
  });
  window.addEventListener('pagehide', () => {
    for (const controller of controllers.values()) controller.destroy();
    controllers.clear();
  });
  window.addEventListener('pageshow', scan);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan, { once: true });
  } else {
    scan();
  }
})();
